export const INQUIRY_RETURN_STORAGE_KEY = 'lt.inquiryReturnPath';

const MAX_AGE_MS = 24 * 60 * 60 * 1000;
const INQUIRY_PATH = /^\/l\/[^/?#]+\/[^/?#]+\/inquiry\/[a-z0-9-]+$/;

export const sanitizeInquiryReturnPath = path => {
  if (typeof path !== 'string') {
    return null;
  }

  const trimmed = path.trim();
  return INQUIRY_PATH.test(trimmed) ? trimmed : null;
};

export const rememberInquiryReturnPath = pathname => {
  const path = sanitizeInquiryReturnPath(pathname);
  if (!path || typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.setItem(
      INQUIRY_RETURN_STORAGE_KEY,
      JSON.stringify({ path, savedAt: Date.now() })
    );
  } catch (error) {
    // Private mode and quota failures should not block the inquiry.
  }
};

export const readInquiryReturnPath = (now = Date.now()) => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const raw = window.localStorage.getItem(INQUIRY_RETURN_STORAGE_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw);
    const path = sanitizeInquiryReturnPath(parsed && parsed.path);
    const savedAt = Number(parsed && parsed.savedAt);
    if (!path || !Number.isFinite(savedAt) || now - savedAt > MAX_AGE_MS) {
      window.localStorage.removeItem(INQUIRY_RETURN_STORAGE_KEY);
      return null;
    }

    return path;
  } catch (error) {
    return null;
  }
};
